import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import { TemplateExcelDataInfo } from "services/models";
import { labeltextBreak } from "@utils/index";
import { IRadioValue } from "@utils/template/excelTemplate";

interface IDailyCheckField {
  setting: TemplateExcelDataInfo;
  value: IRadioValue[];
  onChange: (value: any[]) => void;
  reportItem: any;
  disabled?: boolean;
}

const DailyCheckField = ({
  setting,
  value,
  onChange,
  reportItem,
  disabled,
}: IDailyCheckField) => {
  const [list, setList] = useState<Array<any>>([]);

  useEffect(() => {
    if (setting.master && reportItem) {
      setList([...reportItem]);
    }
  }, [setting, reportItem]);

  return (
    <FormControl>
      <InputLabel>{labeltextBreak(setting.name)}</InputLabel>
      {list.map((master, i) => {
        const check = value?.length > i ? value[i].index : -1;
        return (
          <React.Fragment key={i}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                p: 1,
              }}
            >
              <Typography
                sx={{ flexGrow: 1, wordBreak: "break-all" }}
                className="IgnoreExtractRuleTarget"
              >
                {master.name}
              </Typography>
              <ButtonGroup sx={{ ml: 1 }}>
                {setting.radio?.map((radio, n) => {
                  return (
                    <Button
                      onClick={() => {
                        const newValue = [...value];
                        if (newValue[i].index == n) {
                          // 選択を解除
                          newValue[i] = {
                            index: -1,
                            value: setting.uncheckedResultText || "",
                          };
                        } else {
                          newValue[i] = { index: n, value: radio.text };
                        }
                        onChange([...newValue]);
                      }}
                      variant={check == n ? "contained" : "outlined"}
                      disabled={disabled}
                      key={n}
                    >
                      {radio.label}
                    </Button>
                  );
                })}
              </ButtonGroup>
            </Box>
            <Divider />
          </React.Fragment>
        );
      })}
    </FormControl>
  );
};

export default DailyCheckField;
